import Immutable from 'seamless-immutable';
import ActionTypes from './../common/ActionTypes';

const DEFAULT_STATE = Immutable({
  project: undefined,
  workLogs: [],
});

export default function(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case ActionTypes.PROJECT_CLICKED:
      return state.setIn(['project'], action.project, { deep: true });
    case ActionTypes.PROJECT_DETAILS_WORK_LOG_CLEAR:
      return state.setIn(['workLogs'], [], { deep: true });
    case ActionTypes.PROJECT_DETAILS_WORK_LOG_FETCHED:
      return state.setIn(['workLogs'], action.workLogs, { deep: true });
    case ActionTypes.PROJECT_UPDATED:
      if (state.project && state.project.id === action.project.id) {
        return state.setIn(['project'], action.project, { deep: true });
      }
      return state;
    case ActionTypes.PROJECT_DELETED:
      if (state.project && state.project.id === action.project.id) {
        return state.setIn(['project'], undefined, { deep: true });
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/projectDetails.js